import React, { useEffect } from "react";
import Nav from "react-bootstrap/esm/Nav";
import NavItem from "react-bootstrap/esm/NavItem";
import NavLink from "react-bootstrap/esm/NavLink";
import TabContainer from "react-bootstrap/esm/TabContainer";
import TabContent from "react-bootstrap/esm/TabContent";
import TabPane from "react-bootstrap/esm/TabPane";
import classMap from "../../helpers/classMap";
import { TabsProps, TabProps } from "./tabs.props";
import "./tabs.scss";

const Tabs = (props: TabsProps) => {
  const { defaultActiveKey, activeKey, onTabSelect, className, items, mpngStyle, mountOnEnter, unmountOnExit } = props;

  useEffect(() => {
    const navLinks = document.querySelectorAll(".educator-tabs .nav-link");
    navLinks.forEach((link) => {
      if (items.find((item) => item.title === link.textContent)) {
        link.setAttribute("data-text", link.textContent);
      }
    });
  });

  return (
    //Will use default behavior if activeKey, onSelect, defaultActiveKey are not provided
    <div
      className={classMap("educator-tabs-container", className, mpngStyle ? "mpng-style" : "")}
      data-testid="educator-tabs"
    >
      <TabContainer
        id="educator-tabs"
        activeKey={activeKey}
        onSelect={onTabSelect}
        defaultActiveKey={defaultActiveKey ?? items[0]?.eventKey}
        mountOnEnter={mountOnEnter}
        unmountOnExit={unmountOnExit}
      >
        <Nav className="educator-tabs-nav">
          {items.map((child: TabProps) => (
            <NavItem className="educator-tabs-nav-item" key={child.eventKey}>
              <NavLink
                data-text={typeof child.title === "string" ? child.title : ""}
                className={classMap(
                  "educator-tabs-nav-link",
                  typeof child.title === "string" ? "format-active-text" : ""
                )}
                eventKey={child.eventKey}
              >
                {child.title}
              </NavLink>
            </NavItem>
          ))}
        </Nav>
        <TabContent className="educator-tabs-content">
          {items.map((child: TabProps) => (
            <TabPane className="educator-tabs-pane" key={child.eventKey} eventKey={child.eventKey}>
              {child.content}
            </TabPane>
          ))}
        </TabContent>
      </TabContainer>
    </div>
  );
};

export default Tabs;
